export function collectRows<Sample, Row, Key>(
  samples: Sample[],
  filter: (sample: Sample) => boolean,
  getNewRow: (sample: Sample) => Row | null,
  getRowKey: (sample: Sample) => Key,
  updateRow: (row: Row, sample: Sample) => void,
) {
  const result = new Map<Key, Row>();

  samples.forEach((sample) => {
    if (!filter(sample)) {
      return;
    }

    const rowKey = getRowKey(sample);

    if (!rowKey) {
      throw new Error(`no key`);
    }

    const hasKey = result.has(rowKey);
    const row = hasKey ? result.get(rowKey)! : getNewRow(sample);
    if (!row) {
      return;
    }
    if (!hasKey) {
      result.set(rowKey, row);
    }

    updateRow(row, sample);
  });

  return Array.from(result.values());
}
